module.exports = __webpack_public_path__ + "img/bnr4.48dceb62.png";